export const declOfNum = (n: number, text_forms: [string, string, string]) => { // 1 4 5
    n = Math.abs(n) % 100; 

    const n1 = n % 10;

    if (n > 10 && n < 20) { return text_forms[2]; }
    if (n1 > 1 && n1 < 5) { return text_forms[1]; }
    if (n1 === 1) { return text_forms[0]; }

    return text_forms[2];
};

export const prepareAge = (createdAt: number) => {
    const createdAtDate = new Date(createdAt);
    const diffTime = Math.abs(Number(new Date()) - Number(createdAtDate));
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return {
        // isOld: diffDays >= DAYS_TO_GET_OLD,
        age: diffDays
    };
}
